import { Component, computed, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { I18nService } from '../../core/i18n.service';
import { SiteConfigService } from '../../core/site-config.service';
import { ResponsiveImageComponent } from '../../shared/responsive-image.component';
import { BlogItem, BlogService } from './blog.service';

@Component({
  selector: 'app-blog-home-widget',
  imports: [ResponsiveImageComponent, RouterLink],
  template: `
    <section
      class="blog-home"
      [class.blog-home--global]="variant() === 'globalEditorial'"
      [class.blog-home--mystic]="variant() === 'mysticFortune'"
    >
      <div class="section-head">
        <p class="eyebrow">{{ i18n.t('blog') }}</p>
        <h2>{{ i18n.t('blogHomeTitle') }}</h2>
        <a [routerLink]="i18n.routePath('blog')">{{ i18n.t('blogAll') }}</a>
      </div>

      <div class="blog-rail">
        @for (item of items(); track item.id) {
          <article class="blog-card">
            <div class="media">
              @if (item.imageUrl) {
                <app-responsive-image
                  [url]="item.imageUrl"
                  [mediaSizes]="item.imageSizes"
                  [alt]="item.title"
                  displaySizes="(max-width: 760px) 86vw, (max-width: 1100px) 42vw, 430px"
                />
              }
            </div>
            <div class="content">
              <span>{{ minutesLabel(item.readingMinute || 1) }}</span>
              <h3>{{ item.title }}</h3>
              <p>{{ item.preview }}</p>
              <a [routerLink]="i18n.routePath('blogDetail', { slug: item.slug })">{{ i18n.t('blogReadShort') }}</a>
            </div>
          </article>
        } @empty {
          <article class="empty-card">
            <h3>{{ i18n.t('blogLoadingTitle') }}</h3>
            <p>{{ i18n.t('blogLoadingDescription') }}</p>
          </article>
        }
      </div>
    </section>
  `,
  styleUrl: './blog-widgets.scss'
})
export class BlogHomeWidgetComponent {
  private readonly blog = inject(BlogService);
  protected readonly i18n = inject(I18nService);
  private readonly site = inject(SiteConfigService);
  protected readonly items = signal<BlogItem[]>([]);
  protected readonly variant = computed(() => this.site.config().design.widgets['blogHome'] ?? 'globalEditorial');

  protected minutesLabel(value: number): string { return this.i18n.t('blogMinutesRead').replace(':minutes', String(value)); }

  constructor() {
    void this.load();
  }

  private async load(): Promise<void> {
    try {
      const data = await this.blog.list(1, 8);
      this.items.set(data.items);
    } catch {
      this.items.set([]);
    }
  }
}
